//
//
//
//
//
//
//
//
//
//
//

import uniIcon from "@/components/uni-icon/uni-icon.vue"
export default{
  data () {
    return {
      email: '',
      loading:false,
      iconShow:false
    }
  },
  components:{uniIcon},
  watch:{
    email(val,old){
      if(val.length>0){
        this.iconShow = true
      } else {
        this.iconShow = false
      }
    }
  },
  onLoad () {
    this.queryData()
  },
  methods: {
    myEmail(e){
		this.email=e.target.value
	},
    //内容清空
    clearContent(){
      this.email = ''
    },
    //获取信息
    queryData () {
      let _this = this
      this.$ajax({
        method: 'post',
        url: '/weChat/member/queryById',
        data: {
          memberId: this.$store.state.userInfo.id
        },
        success(res){
          _this.email = res.data.email
        }
      })
    },
    //更新
    update () {
      let _this = this
      if (_this.testEmail(_this.email) || !_this.email) {
         _this.loading = true
        this.$ajax({
          method: 'post',
          url: '/weChat/member/updateById',
          data: {
            memberId: this.$store.state.userInfo.id,
            email: _this.email
          },
          success(res){
            _this.loading = false
            uni.navigateBack({
              delta: 1
            })
          }
        })
      } else {
        uni.showToast({
          title: '邮箱地址格式不正确!',
          icon: 'none'
        })
      }
    },
    testEmail () {
      return /^[a-zA-Z\d]+([-_.][a-zA-Z\d]+)*@[a-zA-Z\d]+\.[a-zA-Z\d]{2,4}$/.test(this.email)
    },
  }
}
